import { render, staticRenderFns } from "./SafetyRecord.vue?vue&type=template&id=1741df7e&scoped=true&"
import script from "./SafetyRecord.vue?vue&type=script&lang=js&"
export * from "./SafetyRecord.vue?vue&type=script&lang=js&"
import style0 from "./SafetyRecord.vue?vue&type=style&index=0&id=1741df7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1741df7e",
  null
  
)

export default component.exports